<template>
  <div class="row">
    <div class="flex md12" style="font-size: 15px, color: black">
      <vxe-toolbar>
        <template #buttons>
          <vxe-input
            v-model="filterName_detable"
            type="search"
            placeholder="Input a key word"
            @keyup="searchEvent_detable"
          ></vxe-input>
          <vxe-button @click="exportDataEvent"
            ><a-icon type="cloud-download" /> Download
          </vxe-button>
        </template>
      </vxe-toolbar>
      <vxe-table
        border
        show-overflow
        :data="tableData_detable"
        row-id="id"
        class="my-sort"
        size="small"
        ref="xTable"
        align="center"
        header-align="center"
        :column-config="{ isHover: true }"
        :sort-config="{
          showIcon: false,
          trigger: 'all',
          defaultSort: { field: 'NES', order: 'asc' },
        }"
        @header-cell-click="headerCellClickEvent"
      >
        <vxe-column field="pathway" title="Dataset" type="html">
          <!-- 点击跳转到相关页面 -->
          <template #default="{ row }">
            <a
              v-if="row.pathway.split('_')[2].startsWith('SC')"
              :href="`http://research.gzsys.org.cn/perturbdb/#/perturbedgenes?datasetId=${
                row.pathway.split('_')[2]
              }&gene=${row.pathway.split('_')[0]}`"
              target="_blank"
              style="color: blue"
            >
              {{ row.pathway }}
            </a>
            <a
              v-else
              :href="`http://research.gzsys.org.cn/perturbdb/#/bulkseq?datasetID=${
                row.pathway.split('_')[2]
              }&gene=${row.pathway.split('_')[0]}`"
              target="_blank"
              style="color: blue"
            >
              {{ row.pathway }}
            </a>
          </template>
        </vxe-column>
        <vxe-column field="pval" title="P-value" type="html" sortable>
          <template #header="{ column }">
            <span>{{ column.title }}</span>
            <span class="custom-sort" :class="{ 'is-order': column.order }">
              <i
                :class="[
                  column.order
                    ? `vxe-icon-sort-numeric-${column.order}`
                    : 'vxe-icon-sort',
                ]"
              ></i>
            </span> </template
        ></vxe-column>
        <vxe-column field="padj" title="FDR p-value" type="html" sortable>
          <template #header="{ column }">
            <span>{{ column.title }}</span>
            <span class="custom-sort" :class="{ 'is-order': column.order }">
              <i
                :class="[
                  column.order
                    ? `vxe-icon-sort-numeric-${column.order}`
                    : 'vxe-icon-sort',
                ]"
              ></i>
            </span>
          </template>
        </vxe-column>
        <vxe-column field="NES" title="NES" type="html" sortable>
          <template #header="{ column }">
            <span>{{ column.title }}</span>
            <span class="custom-sort" :class="{ 'is-order': column.order }">
              <i
                :class="[
                  column.order
                    ? `vxe-icon-sort-numeric-${column.order}`
                    : 'vxe-icon-sort',
                ]"
              ></i>
            </span> </template
        ></vxe-column>
        <vxe-column field="size" title="size" type="html" sortable>
          <template #header="{ column }">
            <span>{{ column.title }}</span>
            <span class="custom-sort" :class="{ 'is-order': column.order }">
              <i
                :class="[
                  column.order
                    ? `vxe-icon-sort-numeric-${column.order}`
                    : 'vxe-icon-sort',
                ]"
              ></i>
            </span> </template
        ></vxe-column>
        <!-- <vxe-column field="timestamp" title="Timestamp" type="html">
        </vxe-column> -->
        <vxe-column field="Plot" title="GSEA plot" type="html">
          <template #default="{ row }">
            <a-button
              type="primary"
              @click="PlotGSEA(row.pathway, row.timestamp)"
              >View</a-button
            >
          </template>
        </vxe-column>
      </vxe-table>
      <vxe-pager
        background
        size="small"
        :loading="loading_detable"
        :current-page="tablePage_detable.currentPage"
        :page-size="tablePage_detable.pageSize"
        :total="tablePage_detable.totalResult"
        :page-sizes="[15, 20, 50, 100]"
        :layouts="[
          'PrevPage',
          'JumpNumber',
          'NextPage',
          // 'FullJump',
          'Sizes',
          'Total',
        ]"
        @page-change="handlePageChange_table"
      >
      </vxe-pager>
    </div>
    <a-modal
      title="Pathway enrichment figure from PGSEA"
      :visible="visible"
      :maskClosable="false"
      :destroyOnClose="true"
      :keyboard="false"
      :closable="false"
      style="margin-top: 300px"
      :height="600"
      :width="1000"
      @ok="handleOk"
      @cancel="handleCancel"
      :cancel-button-props="{ props: { disabled: true } }"
    >
      <a-spin
        size="large"
        :spinning="gsea_visible"
        tip="Plotting... please wait"
      >
        <img :src="this.pngSrc" width="100%" />
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import axios from "axios";
import XEUtils from "xe-utils";

export default {
  props: ["resultName"],
  data() {
    return {
      // 绘图
      pngSrc: null,
      visible: false,
      gsea_visible: true,
      childCols: [
        { type: "seq", title: "Sequence" },
        { field: "name", title: "Name" },
        { field: "role", title: "Role" },
        { field: "age", title: "Age" },
        { field: "sex", title: "Sex" },
      ],
      // tableData: [],
      //加载
      spinning: true,
      //全表搜索
      filterName_detable: "",
      tempdata_detable: [],
      //分页
      getdata_detable: null, //必须要生成这个data
      loading_detable: false,
      tableData_detable: [],
      tablePage_detable: {
        currentPage: 1,
        pageSize: 15,
        totalResult: 0,
      },
    };
  },
  watch: {
    resultName() {
      axios
        .get(
          "http://research.gzsys.org.cn/perturbdb/data/upload/temp/" +
            this.resultName +
            ".json"
        )
        .then((response) => {
          var filteredArray = response.data.sort(function (item1, item2) {
            return item1.NES - item2.NES;
          });
          this.getdata_detable = filteredArray;
          this.findList_detable(this.getdata_detable);
          this.tablePage_detable.currentPage = 1; //必须重置到第一页
          this.spinning = false;
        });
    },
  },
  methods: {
    PlotGSEA(pathId, filename) {
      this.visible = true;
      this.gsea_visible = true;
      this.pngSrc = null;
      axios
        .get("http://research.gzsys.org.cn/perturbdb/API/tools/plotGSEA.php", {
          params: {
            filename: filename,
            pathId: pathId,
          },
        })
        .then((response) => {
          this.pngSrc =
            "http://research.gzsys.org.cn/perturbdb/data/upload/temp/" +
            response.data;
          this.gsea_visible = false;
        });
    },
    headerCellClickEvent({
      column,
      triggerResizable,
      triggerSort,
      triggerFilter,
    }) {
      // 如果触发了列的其他功能按钮
      console.log(column["field"]);
      if (
        column.sortable &&
        !(triggerResizable || triggerSort || triggerFilter)
      ) {
        // this.tcgaLoading = true;
        if (column.order === "desc") {
          axios
            .get(
              "http://research.gzsys.org.cn/perturbdb/data/upload/temp/" +
                this.resultName +
                ".json"
            )
            .then((response) => {
              var filteredArray = response.data.sort(function (item1, item2) {
                return item1.NES - item2.NES;
              });
              this.getdata_detable = filteredArray;
              this.$refs.xTable.clearSort();
              this.findList_detable(this.getdata_detable);
              this.tablePage_detable.currentPage = 1; //必须重置到第一页
              this.spinning = false;
            });
        } else if (column.order === "asc") {
          this.$refs.xTable.sort(column.property, "desc");
          var jiangxu = this.getdata_detable.sort(
            (a, b) => b[column.field] - a[column.field]
          ); // 按照 num 属性降序排序
          this.getdata_detable = jiangxu;
          this.findList_detable(this.getdata_detable);
          // this.tcgaLoading = false;
        } else {
          this.$refs.xTable.sort(column.property, "asc");
          //var field = column.field;
          var shengxu = this.getdata_detable.sort(
            (a, b) => a[column.field] - b[column.field]
          ); // 按照 num 属性降序排序
          this.getdata_detable = shengxu;
          this.findList_detable(this.getdata_detable);
          // this.tcgaLoading = false;
        }
      }
    },
    formatAmount({ cellValue }) {
      return XEUtils.commafy(XEUtils.toNumber(cellValue));
    },
    handleOk() {
      this.visible = false;
    },
    handleCancel() {
      this.visible = false;
    },

    findList_detable(data) {
      this.loading_detable = true;
      setTimeout(() => {
        const list = data;
        this.loading_detable = false;
        this.tablePage_detable.totalResult = list.length;
        this.tableData_detable = list.slice(
          (this.tablePage_detable.currentPage - 1) *
            this.tablePage_detable.pageSize,
          this.tablePage_detable.currentPage * this.tablePage_detable.pageSize
        );
      }, 300);
    },
    // 分页响应按钮
    handlePageChange_table({ currentPage, pageSize }) {
      this.tablePage_detable.currentPage = currentPage;
      this.tablePage_detable.pageSize = pageSize;
      if (this.tempdata_detable.length == 0) {
        this.findList_detable(this.getdata_detable);
      } else {
        this.findList_detable(this.tempdata_detable);
      }
    },
    //全标查询
    searchEvent_detable() {
      this.tablePage_detable.currentPage = 1; //必须重置到第一页
      const filterName = XEUtils.toValueString(this.filterName_detable)
        .trim()
        .toLowerCase();
      if (filterName) {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = ["pathway"];
        const rest = this.getdata_detable.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key])
                .toLowerCase()
                .indexOf(filterName) > -1
          )
        );
        this.tempdata_detable = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `${match}`
            );
          });
          return item;
        });
        this.findList_detable(this.tempdata_detable);
      } else {
        // 必须装回来
        this.tempdata_detable = [];
        this.findList_detable(this.getdata_detable);
      }
    },
    // 导出底物蛋白列表
    exportDataEvent() {
      if (this.tempdata_detable.length == 0) {
        const list = this.getdata_detable;
        this.$refs.xTable.exportData({
          filename: this.resultName + "_all_PGSEA-Result",
          type: "txt",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      } else {
        if (this.filterName_detable == "" || this.filterName_detable == " ") {
          const list = this.getdata_detable;
          this.$refs.xTable.exportData({
            filename: this.resultName + "_all_PGSEA-Result",
            type: "txt",
            isHeader: true,
            isFooter: true,
            data: list,
          });
        } else {
          const list = this.tempdata_detable;
          this.$refs.xTable.exportData({
            filename: this.filterName_detable + "_related_PGSEA-Result",
            type: "txt",
            isHeader: true,
            isFooter: true,
            data: list,
          });
        }
      }
    },
  },
};
</script>
<style>
.keyword-lighten {
  color: #000;
  background-color: #ffff00;
}
.my-sort .custom-sort {
  padding: 0 4px;
}
.my-sort .custom-sort.is-order {
  color: #409eff;
}
</style>
